import { render, staticRenderFns } from "./bodyComposition.vue?vue&type=template&id=2c8e9b02&scoped=true&"
import script from "./bodyComposition.vue?vue&type=script&lang=js&"
export * from "./bodyComposition.vue?vue&type=script&lang=js&"
import style0 from "./bodyComposition.vue?vue&type=style&index=0&id=2c8e9b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8e9b02",
  null
  
)

export default component.exports